import { SolucionPage } from "@/components/SolucionPage";
import { getSolucion } from "@/lib/soluciones";

export default function Embudo5Estrellas() {
  const solucion = getSolucion("embudo-5-estrellas")!;
  return <SolucionPage solucion={solucion} />;
}
